module.exports = __webpack_public_path__ + "media/images/black_history_month/person4-b86a8659e0e186ed17be794f88de013e.png";